import { saveAs } from "file-saver";
import MyDocument from "./MyDocument.jsx";
import { pdf } from "@react-pdf/renderer";
import structure from "../utils/structure.jsx";
import { showRoof } from "../redux/roomSlice";
import { useDispatch, useSelector } from "react-redux";

export default function Footer(props) {
    
    const dispatch = useDispatch();

    const generatePdf = () => {
        dispatch(showRoof());
        setTimeout(() => { downloadPdf(); }, 10);
    }

    const downloadPdf = async () => {
        const fileName = "Presupuesto.pdf";
        const blob = await pdf(<MyDocument data={getInfo()} image={props.getImage()} />).toBlob();
        saveAs(blob, fileName);
    };

    function getInfo() {
        const res = {
            info : [
                ["Modelo de vivienda", model, apiData.modelo],
                ["Cubierta", roof, apiData.cubierta],
                ["Materiales de exterior", exterior, apiData.exterior],
                ["Acento", extAccent, apiData.acentoExt],
                ["Materiales de interior", interior, apiData.interior],
                ["Acento", intAccent, apiData.acentoInt]
            ],
            extras: getExtras(),
            total: apiData.total
        }

        return res;
    }

    function getExtras() {
        let res = [];
        for (let i = 0; i < extras.length; i++) {
            res.push([structure[4].elements[extras[i]], Object.values(apiData.extras)[extras[i]]]);
        }
        return res;
    }

    const model = useSelector((state) => state.roomData.model);
    const roof = useSelector((state) => state.roomData.roof);
    const exterior = useSelector((state) => state.roomData.exterior);
    const interior = useSelector((state) => state.roomData.interior);
    const extAccent = useSelector((state) => state.roomData.extAccent);
    const intAccent = useSelector((state) => state.roomData.intAccent);
    const extras = useSelector((state) => state.roomData.extras);
    const apiData = useSelector((state) => state.roomData.apiData);

    return (
        <div id="footer" className={props.htmlClass}>
            <p>{model}</p>
            <div style={{ display: "flex", alignItems: "center" }}>
                <p>Total: {apiData.total}€</p>
                <button id="download" onClick={generatePdf}>
                    Generar presupuesto
                </button>
            </div>
        </div>
    );
}
